import { render, staticRenderFns } from "./prediction-lines-side-action.vue?vue&type=template&id=165bbd19"
import script from "./prediction-lines-side-action.ts?vue&type=script&lang=js&external"
export * from "./prediction-lines-side-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports